import requset from "utils/request";
import baseURL from '@/api/env.js'
/* ============消息======== */
/* 消息列表 */
export function getMoticeApi(params) {
    return requset({
        url: `${baseURL.AHEAD}/writer/writer/notice/list`,
        method: "GET",
        params
    });
}
// /* 作者消息列表 */
// export function AuthorNotice(params) {
//   return requset({
//     url: `${baseURL.AHEAD}/interact/notice/list`,
//     method: "GET",
//     params
//   });
// }
// /* 查看未读 */
// export function noticecount(params) {
//   return requset({
//     url: `${baseURL.AHEAD}/interact/notice/count`,
//     method: "GET",
//     params
//   });
// }
// /* 设置已读 */
// export function noticed(data) {
//   return requset({
//     url: `${baseURL.AHEAD}/interact/notice/read/all`,
//     method: "POST",
//     data
//   });
// }
